const TransfertFooter = ({ destinationType, destinationTypes, errors, setDestinationType, onTransfert, disabled }) => (

  <div className="d-flex justify-content-between align-items-end mt-3">
    <div className="d-flex align-items-center gap-3">
      <label className="form-label fw-bold mb-0">Type destination</label>
      <select
        // className="form-select compact-control"
        className={`form-select compact-control ${errors?.type ? "is-invalid" : ""
          }`}
        style={{ width: "260px", marginLeft: "60px", marginRight: "60px" }}
        value={destinationType}
        onChange={e => setDestinationType(e.target.value)}
      >
        <option value="">-- Sélectionnez un type --</option>
        {destinationTypes.map(t => (
          <option key={t.value} value={t.value}>
            {t.text}
          </option>
        ))}
      </select>
      {errors?.type && (
        <div className="invalid-feedback">
          {errors.type}
        </div>
      )}
    </div>
    <button
      className="btn btn-success"
      disabled={disabled}
      onClick={onTransfert}
    >
      Transférer
    </button>

  </div>

);

export default TransfertFooter;
